import IMask from 'imask';

/** Єдине джерело правди */
export const PHONE_MASK = '+{38}(000)-000-00-00';
export const PHONE_PLACEHOLDER = '+38 (095) 123-45-67';
export const PHONE_REGEX = /^\+38\(0\d{2}\)-\d{3}-\d{2}-\d{2}$/;

export const UA_OPERATOR_WHITELIST = new Set([
  '044','039','067','068','096','097','098','050','066','095',
  '099','063','073','093','091','092','094','089','075',
]);

/* ---------- helpers ---------- */

export const normalizeDashes = (s = '') =>
  String(s).replace(/[\u2013\u2014\u2212]/g, '-');

export const normalizePhoneDigits = (v = '') =>
  String(v).replace(/\D/g, '');

/**
 * 10 цифр користувача (0XXYYYYYYY)
 */
export const getDigits10 = (maskedPhone = '', mask = null) => {
  let raw = mask?.unmaskedValue || '';
  if (!raw) raw = normalizePhoneDigits(normalizeDashes(maskedPhone));

  let digits = normalizePhoneDigits(raw);

  if (digits.startsWith('38')) digits = digits.slice(2);
  if (digits.length > 10) digits = digits.slice(-10);

  return digits;
};

export const getOperatorCode = (maskedPhone = '', mask = null) =>
  getDigits10(maskedPhone, mask).slice(0, 3);

export const isCompletePhone = (maskedPhone = '', mask = null) =>
  getDigits10(maskedPhone, mask).length === 10;

export const hasAnyPhoneInput = (maskedPhone = '', mask = null) =>
  getDigits10(maskedPhone, mask).length > 0;

export const isValidPhoneFormat = (maskedPhone = '') =>
  PHONE_REGEX.test(normalizeDashes(String(maskedPhone).trim()));

export const isAllowedUaOperator = (maskedPhone = '', mask = null) =>
  UA_OPERATOR_WHITELIST.has(getOperatorCode(maskedPhone, mask));

/**
 * Універсальний state
 */
export const getPhoneState = (maskedPhone = '', mask = null) => {
  const masked = normalizeDashes(String(maskedPhone || ''));
  const digits10 = getDigits10(masked, mask);

  return {
    masked,
    digits10,
    hasAnyInput: digits10.length > 0,
    isComplete: digits10.length === 10,
    operatorCode: digits10.slice(0, 3),
    formatOk: isValidPhoneFormat(masked),
    operatorOk: isAllowedUaOperator(masked, mask),
  };
};

/**
 * ЄДИНА точка ініціалізації маски
 */
export const applyPhoneMask = (inputEl, opts = {}) => {
  if (!inputEl) return null;

  const {
    lazy = true,
    placeholderChar = ' ',
    placeholder = PHONE_PLACEHOLDER,
  } = opts;

  inputEl.placeholder = placeholder;

  return IMask(inputEl, {
    mask: PHONE_MASK,
    lazy,
    placeholderChar,
    placeholder,
  });
};
